import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { TextField } from "@/shared/components/Form/TextField";
import { AutocompleteField } from "@/shared/components/Form/AutocompleteField";
import type {
  PlatformBlockComponent,
  PlatformBlockProps,
} from "../../../types";
import { BlockFormHeader } from "../BlockFormHeader";

export const TagCard: PlatformBlockComponent = ({
  name,
  platformId,
  queries,
}: PlatformBlockProps) => {
  const { t } = useTranslation();

  return (
    <Paper sx={{ p: 2 }}>
      <BlockFormHeader blockType="TAG_CARD" />
      <Grid container spacing={2}>
        <Grid size={12}>
          <AutocompleteField
            name={`${name}.tagId`}
            label={t("platformBlocks.tagCard.tag")}
            placeholder={t("platformBlocks.tagCard.tagPlaceholder")}
            fullWidth
            query={queries?.autocompleteTags}
            queryVariables={
              platformId
                ? {
                    filter: { platformId },
                  }
                : undefined
            }
            required
          />
        </Grid>
        <Grid size={12}>
          <TextField
            name={`${name}.maxWidth`}
            label={t("platformBlocks.tagCard.maxWidth")}
            placeholder="sm, md, lg, xl"
            helperText={t("platformBlocks.tagCard.maxWidthHelper")}
            fullWidth
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
